import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared.module';
import { WidgetsComponentsModule } from 'src/app/components/kit/widgets/widgets-components.module';
import { FormsModule } from '@angular/forms';

import { UserRouterModule } from './user-routing.module';
import { UserDashboardComponent } from './dashboard/user-dashboard.component';
import { UserStammdatenComponent } from './stammseite/stammdaten.component';
import { ElementsModule } from '../../components/elements/elements.module';
import { UserCreateComponent } from './create/user-create.component';
import { JsonSchemaRendererModule } from '../../components/renderer/json-schema-renderer.modul';
import { UserEditComponent } from './edit/user-edit.component';
import { UserProjectRolesComponent } from './project-roles/user-project-roles.component';
import { ProjectRolesModule } from '@app/components/project-roles/project-roles.module';

const COMPONENTS = [
	UserDashboardComponent,
	UserStammdatenComponent,
	UserCreateComponent,
	UserEditComponent,
	UserProjectRolesComponent,
];

@NgModule({
	imports: [
		SharedModule,
		UserRouterModule,
		WidgetsComponentsModule,
		FormsModule,
		ElementsModule,
		JsonSchemaRendererModule,
		ProjectRolesModule,
	],
	declarations: [...COMPONENTS]
})
export class UserModule {}
